if (!customElements.get('gift-feel-slider')) {
  class GiftFeelSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.gift-feel__features');
      this.dots  = Array.from(this.querySelectorAll('.gift-feel__dot'));
      this.items = Array.from(this.querySelectorAll('.gift-feel__item'));

      if (!this.track || !this.items.length) return;

      // Dot click → scroll that item into view
      this.dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          this.items[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        });
      });

      // Keep dots in sync as the user scrolls
      this._onScroll = () => {
        const scrollLeft = this.track.scrollLeft;
        const itemW      = this.items[0] ? this.items[0].offsetWidth : 1;
        const index      = Math.round(scrollLeft / itemW);
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      };
      this.track.addEventListener('scroll', this._onScroll, { passive: true });
    }

    disconnectedCallback() {
      if (this.track && this._onScroll) {
        this.track.removeEventListener('scroll', this._onScroll);
      }
    }
  }

  customElements.define('gift-feel-slider', GiftFeelSlider);
}


